import * as React from 'react';
import SVGIcon from '../SVGIcon';

const BreadCrumbSeparatorIcon: React.FC = () => {
  return (
    <SVGIcon viewBox="0 0 7 16" width="7" height="16">
      <path
        d="M6.75204 0.295454L2.53329 15.9688H0.826616L5.04537 0.295454H6.75204Z"
        fill="#86888D"
      />
    </SVGIcon>
  );
};

export default BreadCrumbSeparatorIcon;
